import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  Select,
  MenuItem,
  Typography,
} from '@mui/material';

export default function OrganizationSelectDialog({ open, organizations, onSelect }) {
  const [selectedOrgId, setSelectedOrgId] = useState('');
  
  React.useEffect(() => {
    if (organizations && organizations.length > 0) {
      setSelectedOrgId(organizations[0].orgId);
    }
  }, [organizations]);
  
  const handleChange = (event) => {
    setSelectedOrgId(event.target.value);
  };
  
  const handleConfirm = () => {
    onSelect(selectedOrgId);
  };
  
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ bgcolor: '#2d186c', color: 'primary.contrastText' }}>
        Select Organization
      </DialogTitle>
      <DialogContent sx={{ pt: 3 }}>
        <Typography variant="body1" sx={{ mb: 2, mt: 2 }}>
          Please select which organization's licenses you want to view:
        </Typography>
        <FormControl fullWidth>
          <Select
            value={selectedOrgId}
            onChange={handleChange}
            displayEmpty
            inputProps={{ 'aria-label': 'Select organization' }}
            sx={{ mt: 1 }}
          >
            {organizations?.map((org) => (
              <MenuItem key={org.orgId} value={org.orgId}>
                {org.orgName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button 
          onClick={handleConfirm} 
          variant="contained" 
          disabled={!selectedOrgId}
          sx={{ bgcolor:"#2d186c" }}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}